<template>
  <section class="base-card apple-ease" :class="{ 'is-hoverable': hoverable }">
    <header v-if="$slots.header || title" class="base-card__header">
      <div class="base-card__title-wrap">
        <h3 class="base-card__title">{{ title }}</h3>
        <p v-if="description" class="base-card__desc">{{ description }}</p>
      </div>
      <div v-if="$slots.header" class="base-card__actions">
        <slot name="header" />
      </div>
    </header>

    <div class="base-card__body">
      <slot />
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  hoverable: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped lang="scss">
.base-card {
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
  padding: var(--space-4);
}

.base-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-3);
}

.base-card__title {
  margin: 0;
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-weight: 600;
  color: var(--color-text-primary);
}

.base-card__desc {
  margin-top: var(--space-1);
  font-size: var(--font-size-body-sm);
  line-height: var(--line-height-body-sm);
  color: var(--color-text-secondary);
}

.base-card__actions {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.base-card__body {
  color: var(--color-text-primary);
  font-size: var(--font-size-body);
  line-height: var(--line-height-body);
}

.is-hoverable:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}
</style>
